import React from 'react';
import bem from 'utils/bem';
import Icon from 'components/Icon';

import './index.sass';

const { block } = bem('loader');

const Loader = ({ loading, styles }) => {
    if (loading !== undefined && !loading) return null;
    return (
        <div className={block()} style={styles} >
            <Icon name='loader' type={'png'} />
        </div>
    )
}

export default Loader;
